import React from 'react'
import cn from 'classnames'

import {
  star as StarOutlineIcon,
  starSelected as StarIcon,
} from 'assets/icons/groove/v2'

import { Tooltip } from 'shared/ui'

const StarButton = React.memo(({ isStarred, onStarIconClick }) => {
  const tooltip = isStarred ? 'Unstar [+]' : 'Star [+]'
  return (
    <div className="star">
      <Tooltip position="bottom" tooltip={tooltip}>
        <a
          className={cn('menu-button', { starred: isStarred })}
          onClick={onStarIconClick}
        >
          {isStarred ? <StarIcon /> : <StarOutlineIcon />}
        </a>
      </Tooltip>
    </div>
  )
})

export default StarButton
